import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { BrandButton } from '../../components/button';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const HomeExpiredContacted: FC<Props> = ({ onClick }) => (
  <div>
    <p className="banner-customers__subtitle">
      <FormattedMessage id="home-expired/components/Contacted.tsx/1" />
    </p>
    <BrandButton large onClick={onClick}>
      <FormattedMessage id="home-expired/components/Contacted.tsx/2" />
    </BrandButton>
  </div>
);
